import { useLanguage } from "../i18n/Language";
import React from 'react';
import { useAppointmentWhatsApp } from './QuickContact';

function Footer() {
  const { t } = useLanguage();
  const appointmentWhatsApp = useAppointmentWhatsApp();
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto text-center">
        <p>&copy; {new Date().getFullYear()}{t(" Dr. Bharat Reddy Katta. All rights reserved.")}</p>
        <p className="mt-2">{t("Srikara Hospital, L.B. Nagar, Hyderabad, Telangana 500074")}</p>
        <p className="mt-2"><a href="/services/" className="underline">{t("Orthopaedic services")}</a> · <a href="/#location" className="underline">{t("Location and directions")}</a></p>
        <p className="mt-2">{t("Phone:")}
          <a href="tel:+917893107890" className="text-white hover:underline">+91 78931 07890</a>
          {' | '}
          <a href={appointmentWhatsApp} target="_blank" rel="noopener noreferrer" className="text-white hover:underline">{t("WhatsApp")}</a>
        </p>
      </div>
    </footer>);

}

export default Footer;
